// Copyright (c) Hamilton Manufacturing Corp.
import React, { useEffect, useState } from 'react';
import { QuestRoute } from '../../_common/api/QuestRoutes';
import Modal from '../../_common/Modal';
import ItemList from '../ItemList';
import ForceLocation from '../ForceLocation';
import { HamQuest } from '../../../App';

const Washes = ({ ...props }) => {
    const [washes, setWashes] = useState([]);

    useEffect(() => {
        HamQuest.get(QuestRoute.products.washes)
            .then((res) => setWashes(res))
            .catch(ex => {
                Modal.Show({
                    type: 'error',
                    title: 'Unable to get Washes',
                    body: 'Sorry, something went wrong. Please try again.'
                })
            })
    }, [])

    return (
        <ForceLocation route={'washes'} >
            <ItemList items={washes} />
        </ForceLocation>
    );
}

export default Washes;